import { render } from "./TopRowDayComponent.vue?vue&type=template&id=6354bbf0"
import script from "./TopRowDayComponent.vue?vue&type=script&lang=js"
export * from "./TopRowDayComponent.vue?vue&type=script&lang=js"

import "./TopRowDayComponent.vue?vue&type=style&index=0&id=6354bbf0&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__